<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                flat
                dark
              >
                <v-toolbar-title>Registration form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="firstName"
                    label="First Name"
                    name="firstName"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    v-model="lastName"
                    label="Last Name"
                    name="lastName"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    v-model="email"
                    label="E-mail"
                    name="email"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>

                  <v-text-field
                    v-model="password"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                  ></v-text-field>
                  
                  <v-text-field
                    v-model="validationCode"
                    label="Validation code"
                    name="validationCode"
                    prepend-icon="mdi-lock"
                    type="text"
                  ></v-text-field>

                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="createUser()" color="secondary">Register</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import { CREATE_USER_MUTATION } from '../../graphql/authenticationQueries.js';

  export default {
    props: {
      source: String,
    },
    data () {
      return {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        validationCode: null
      }
    },
    apollo: {
      $client: 'authenticationClient'
    },
    methods: {
      async createUser(){
        const { firstName, lastName, email, password, validationCode } = this.$data;
        try {
          await this.$apollo.mutate({
            mutation: CREATE_USER_MUTATION,
              variables: {
                firstName: firstName,
                lastName: lastName,
                email: email,
                password: password,
                validationCode: validationCode
              }
          });
          alert('Successfully created new user!');
          this.$router.push({path: '/login'})
        }
        catch (error) {
          alert('Something went wrong when attempting to register new user.');
        }
      }
    }
  }
</script>